import { PassCode } from 'components/PassCode'
import { useSelector } from 'react-redux'
import { authSlice } from '../../../../authSlice'
import { useSendPassCode } from './hooks/useSendPassCode'
import { useResendCode } from './hooks/useResendCode'
import { ForgotPasswordContainer } from '../ForgotPasswordContainer'
import { BackButton } from '../BackButton'
import { ButtonLoader } from '@wellesley/ui'
import { getErrorMsg } from '@wellesley/error-kit'
import { useState } from 'react'

export const ForgotPasswordPassCode = () => {
  const [passCode, setPassCode] = useState<number>()
  const [isCodeFulfilled, setIsCodeFulfilled] = useState(false)
  const fields = useSelector(authSlice.selectors.selectForgotPasswordFields)
  const loginField = fields?.login || ''

  const { send, isError, error, isLoading } = useSendPassCode()
  const { resendCode } = useResendCode()

  return (
    <ForgotPasswordContainer>
      <div>
        <PassCode
          errorMsg={getErrorMsg(error)}
          email={loginField}
          isError={isError}
          onResend={() =>
            loginField &&
            void resendCode({
              passwordRecoveryRequest: { login: loginField },
            })
          }
          onSubmit={setPassCode}
          onFullFilled={setIsCodeFulfilled}
        />
        <div className="mt-m flex justify-stretch gap-xs">
          <BackButton className="flex-1" open="request" />
          <ButtonLoader
            size="m"
            variant="primary"
            className="flex-1"
            isLoading={isLoading}
            disabled={!isCodeFulfilled}
            onClick={() => passCode && void send(passCode)}
          >
            Confirm
          </ButtonLoader>
        </div>
      </div>
    </ForgotPasswordContainer>
  )
}
